import { createAction } from 'redux-actions'
import { GET_PRIVACY, GET_TERMS, SET_PRIVACY, SET_TERMS } from './constants'
import { getPrivacyApi, setPrivacyApi, getTermsApi, setTermsApi } from './api'

export const getTermsAction = createAction(GET_TERMS, async () => getTermsApi())
export const setTermsAction = createAction(SET_TERMS, async (data) => setTermsApi(data))
export const getPrivacyAction = createAction(GET_PRIVACY, async () => getPrivacyApi())
export const setPrivacyAction = createAction(SET_PRIVACY, async (data) => setPrivacyApi(data))
